import { render, staticRenderFns } from "./WorkspaceSwitcher.vue?vue&type=template&id=0edc4c26&scoped=true"
import script from "./WorkspaceSwitcher.vue?vue&type=script&lang=js"
export * from "./WorkspaceSwitcher.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSwitcher.vue?vue&type=style&index=0&id=0edc4c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc4c26",
  null
  
)

export default component.exports